module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"stages":{"succeed":"Succeed","failed":"failed","not_yet":"Not yet"}},"vi":{"stages":{"succeed":"Thành công","failed":"Thất bại","not_yet":"Chưa"}}}')
  delete Component.options._Ctor
}
